module.exports = __webpack_public_path__ + "img/knu_gallery11.d62cdc00.jpg";